var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurves({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_02.Curves",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1060.4 733.8",
    style: {
      enableBackground: "new 0 0 1060.4 733.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003E4C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.1,610.4c-3.6,0-6.5-2.9-6.5-6.5c0-2.1,1-4,2.6-5.2l683-510.4c3-2,7-1.2,9,1.8c1.9,2.8,1.3,6.5-1.3,8.6 L215,609.1C213.9,609.9,212.5,610.4,211.1,610.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M932,63.9c0.3-0.9,0.5-1.9,0.4-2.9c1.4-3.9,5.8-5.2,9-6.2c0-0.3-0.5-0.2-0.3-0.6c8.2-1.6,16.3-6.7,26.2-3.7 c0.6,1.8,2.5,3.2,2.6,4.9c1.1,0.7,1.5,2,1.2,3.2c-0.8,0.6-1.7,1.2-2.7,1.7c-3.4-0.8-7-0.3-9.7-0.1c-1.7-1.7-4.7,0.6-6.8,0.3 c-1.2,0.7-2.5,1-3.8,1c-0.1,0.5,0.3,0.4,0.2,0.9c1,1.3,4,0.7,4.5,2.5c2.7,0.1,4,2.8,3.9,4.5c0.2,0.8,0.6,0.2,1,0.8 c0.3,1.1,1.7,2.4,2.3,3.8c0.1,2.3,0.5,4-0.2,5.8c-2.7,6.7-10.2,10.4-16.8,12.4c-0.3-0.1-0.9,0.2-0.7-0.3c-1.3,1.3-3.7,0.3-5.6,0.6 c-0.6-0.5-1.1-1.2-1.4-2c-0.4-0.1-0.2-0.7-0.5-0.8c0-0.2,0.1-0.4,0.2-0.5c0.6-0.3-0.5-0.4-0.3-0.9c0.8-1.4-1-4.1,1.1-5.2 c6.2,0.7,10.8-2.8,15.1-4.9c0.5-1.6,2.2-2,2.5-3.6c0.2-0.6-0.5-0.5-0.5-1c-0.2-0.1-0.5-0.2-0.7-0.2c-1.7-1-4.3-1.6-5.7-2.4 c-0.9,0.5-1.7,0-3-0.2c-2.9,0-5.8-0.6-8.6-1.7c-0.2-0.4-0.3-0.9-1.1-0.8c-0.6-0.7-1.1-1.4-1.6-2.2C932.4,65.3,932.6,64.7,932,63.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M907.2,570.1c0.2-1,0.9-1.5,0.9-2.7c0.9-2.3,1.5-4.6,1.8-7c0.1-0.3,0.4-0.6,0.8-0.7c0.5-4.3,0.1-8.7-1.1-12.9 c0.1-0.9,0.4-1.2,0.2-1.5c-0.1-0.7,0.7-0.5,1.3-0.5c-0.2-1.5-0.5-2.9-1.1-4.3c0.6-1.4,0.6-2.7,1.3-3.8c4.9,1.5,9.3,4.2,13.6,5.2 c6.5,4.7,14.3,8.6,14.8,18.3c-0.3,0.7-0.4,1.5-0.3,2.3c-5.3,9.5-17.3,12.3-27.4,17C907.6,578.5,907.6,574.4,907.2,570.1z  M916.7,547.7c1.8,6.8,1.7,11.8,0.3,19.2c1.9-0.1,2.8-1.5,5.2-1.6c0.2-0.5,0.9-0.8,1.2-1.2c3.8-1.5,7.5-3.1,9.2-6.8 c-1.2-2.2-3.8-3-4.9-5.3c-2.4-0.4-3.3-2.2-5.9-2.4c0-0.2-0.2-0.2-0.2-0.5c-1.7-0.3-3.5-0.7-4.3-1.5 C917.2,547.5,916.9,547.5,916.7,547.7L916.7,547.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M890.2,607.3c-1.4,0-2.8-0.4-3.9-1.3L199.2,94.2c-2.9-2.1-3.5-6.2-1.3-9.1c2.1-2.9,6.2-3.5,9.1-1.3L894,595.6 c2.9,2.1,3.5,6.2,1.3,9.1C894.1,606.4,892.2,607.4,890.2,607.3L890.2,607.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurves);
export default __webpack_public_path__ + "static/media/curves.dfa1c2d41fc8180c2e2fc468151c9357.svg";
export { ForwardRef as ReactComponent };